"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _ToastModule = _interopRequireDefault(require("./Toast.module.css"));
var _excluded = ["bg", "onCancel", "title", "body"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Toast = function Toast(_ref) {
  var bg = _ref.bg,
    onCancel = _ref.onCancel,
    title = _ref.title,
    body = _ref.body,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Toast, _extends({
    onClose: onCancel,
    bg: bg,
    bsPrefix: "toast ".concat(_ToastModule.default.wrapper, " ").concat(!title ? _ToastModule.default.headerOnly : ''),
    "data-variant": bg
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Toast.Header, {
    className: _ToastModule.default.headerContainer,
    style: {
      borderBottom: title ? '1px solid rgba(0, 0, 0, 0.05)' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: title ? title : body
    },
    className: _ToastModule.default.header
  })), title && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Toast.Body, {
    className: _ToastModule.default.bodyContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: body
    },
    className: _ToastModule.default.body
  })));
};
exports.Toast = Toast;
Toast.propTypes = {
  show: _propTypes.default.bool,
  autohide: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  title: _propTypes.default.string,
  body: _propTypes.default.string,
  bg: _propTypes.default.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'])
};
Toast.defaultProps = {
  show: true,
  autohide: true,
  /*title: 'Title',*/
  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  bg: 'primary'
};